import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, Subscription } from 'rxjs';
import { MyCustomRoute, CiceroneData, KioskStyle, Device, Config, DateRange, TimeRange } from '../interfaces/myCustomRoute.interface';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root' 
})
  
export class RestService {
    mac: any;
    apiUrlBase: string = environment.apiUrlBase;
    assistantUrlBase: string = environment.assistantUrlBase;
    survey: any;
    currentLocation: any;

    expiredLicense: any;
    //-------------------- CHECKS PWA VARS ---------------------------

    redirectPage: string = '/home-kiosk';
    appStyle: KioskStyle;
    device: Device

    //----------------------------------------------------------------

    networkStatus: boolean = false;
    networkStatus$: Subscription = Subscription.EMPTY;
   
    myCustomRouteShowHeader: boolean = false;
    myCustomRoute: MyCustomRoute;
    myRecommendedRoutePoints: any;
    ciceroneData: CiceroneData;
    responseData: any;
    langSelector: any;

    startItem: any;
    loadedRoute: boolean = false;

    config: Config = {
        standBy: true,
        keyBoardOnScreen: true,
        kioskMode: true,
        techMode: false
    }

    registerOptions: any = {
        // rangeTime is the arrival/departure time picked in step-calendar, already
        // normalized to whole hours; null when the selection holds no slot.
        calendar: {} as { dateRange?: DateRange, rangeTime?: TimeRange | null },
        // Sitio elegido en el buscador del formulario. `null` = nadie lo tocó y la ruta sale
        // del propio tótem, como siempre (start-location.util.ts).
        startLocation: null,
        travelerType: null,
        categories: [],
        subCategories: [],
        registerBeforeAnswer: [],
        registerAfterAnswer: []
    }

    private dataSubject = new Subject<string>();
    data$ = this.dataSubject.asObservable();

    constructor(public http: HttpClient) { }

    sendData(data: string) {
        this.dataSubject.next(data);
    }

    //--------------------------------------------------------------------------------------------------------------------------------------------------
    //------------------------------------------------------------ INCREMENTO CLICKS -------------------------------------------------------------------
    increaseVisitsPoint(id): Observable<any>{
        return this.http.post(`${this.apiUrlBase}/api/increase-point-views/${id}`, {});
    }

    increaseVisitsEvent(id): Observable<any>{
        return this.http.post(`${this.apiUrlBase}/api/increase-event-views/${id}`, {});
    }

    increaseVisitsPdf(id): Observable<any>{
        return this.http.post(`${this.apiUrlBase}/api/increase-pdf-views/${id}`, {});
    }
    //--------------------------------------------------------------------------------------------------------------------------------------------------
    //------------------------------------------------------------ API PWA ENDPOINTS -------------------------------------------------------------------
    getCiceroneData(mac): Observable<any>{
        return this.http.post(`${this.apiUrlBase}/api/get-cicerone-data-pwa/${mac}`, {});
    }

    getCiceroneDataFallback(): Observable<any>{
        const headers = new HttpHeaders().set('Cache-Control', 'no-cache').set('Pragma', 'no-cache').set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
        return this.http.get(`/assets/kiosk.json`, { headers: headers });
    }

    getLocalSelfieSettings(): Observable<any>{
        const headers = new HttpHeaders().set('Cache-Control', 'no-cache').set('Pragma', 'no-cache').set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
        return this.http.get(`/assets/selfie.json`, { headers: headers });
    }

    getNewCiceroneData(mac: string): Observable<any>{
        return this.http.get(`${this.apiUrlBase}/api/get-home-kiosk-data/${mac}`);   
    }

    getRoute(id): any{
        return this.http.post(`${this.apiUrlBase}/api/get-cicerone-route-pwa/${id}`, {});
    }

    //--------------------------------------------------------------------------------------------------------------------------------------------------
    //------------------------------------------------------- RUTAS RECOMENDADAS (ASISTENTE) -----------------------------------------------------------
    // Mismo origen que la web: el planificador del asistente. HRS-2958.
    getRecommendedRouteList(clientId, clientType, appId): Observable<any>{
        return this.http.get(`${this.assistantUrlBase}/api/recommended-route-list/${clientId}/${clientType}/${appId}`);
    }

    // Es una LECTURA aunque sea POST: el asistente no expone un GET de la plantilla, y sin
    // `is_recommended` devolvería la ruta de un viajero en vez de la ruta publicada.
    getRecommendedRouteCompleted(token, clientId, clientType, appId): Observable<any>{
        return this.http.post(`${this.assistantUrlBase}/api/get-route-completed`, {
            token: token,
            client_id: clientId,
            client_type: clientType,
            app_id: appId,
            is_recommended: true
        });
    }

    // Crea una instancia por-visitante de una plantilla recomendada con los datos del registro
    // (HRS-3322): mismo endpoint y campos que la web (`register-user-submission.service.ts`).
    // El asistente aplica la hora tal y como la aplica hoy: filtra el día 1; los días 2+
    // conservan las horas de la plantilla. Devuelve `{ token }` con el token de la instancia.
    instantiateRecommendedRoute(payload): Observable<any>{
        return this.http.post(`${this.assistantUrlBase}/api/recommended-route/instantiate`, payload);
    }

    // Lee una ruta INSTANCIADA (token de planned_route). Igual que la web: mismo endpoint que la
    // plantilla pero con `is_recommended: false`, porque el token ya no es el de la plantilla.
    getInstantiatedRouteCompleted(token, clientId, clientType, appId): Observable<any>{
        return this.http.post(`${this.assistantUrlBase}/api/get-route-completed`, {
            token: token,
            client_id: clientId,
            client_type: clientType,
            app_id: appId,
            is_recommended: false
        });
    }

    saveRoute(data): any{
        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        return this.http.post(`${this.apiUrlBase}/api/pwa-save-route`, formData );
    }

    updateRoute(data): any{
        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        return this.http.post(`${this.apiUrlBase}/api/pwa-update-route`, formData );
    }

    saveSurvey(data): any{
        return this.http.post(`${this.apiUrlBase}/api/pwa-save-survey`, { data });
    }

    qrSelfie(data): any{
        // return this.http.post(`${this.apiUrlBase}/api/pwa-save-survey`, { data });
        return this.http.post(environment.selfieQrUrl, { data });
    }

    //PRUEBA SOCKET
    // @deprecated DEAD CODE - DELETE AS SOON AS SOMEONE CONFIRMS NOTHING NEEDS IT.
    // An old Bilbao project that was cancelled (confirmed by its author). The endpoint exists
    // in no backend (0 hits for `get-reels-by-id` in cms8, cms12 and cicerone-back), and the
    // only caller - socket.service.ts:48 - runs from setupSocketConnection(), whose own caller
    // license.page.ts:242 is commented out. `cicerone-back.local` is a developer's local
    // domain that got committed, so HRS-2848 left it here instead of giving dead code an
    // environment key. If it is ever revived, use `${this.apiUrlBase}/api/get-reels-by-id`.
    getReel(id): any{
        const formData = new FormData();
        formData.append('id', JSON.stringify(id));
        formData.append('device', JSON.stringify(this.device.device));
        return this.http.post(`http://cicerone-back.local/api/get-reels-by-id`, formData);
    }

    updateCiceroneData(data){
        this.ciceroneData = { ...this.ciceroneData,
            interestPoints: data.interestPoints,
            hikings: data.hikings,
            events: data.events,
            pdfs: data.pdfs,
            travelerType: data.travelerType,
            categories: data.categories,
            subCategories: data?.subCategories ?? data?.subcategories ?? [],
            tags: data.tags,
            registerAfter: data.registers?.registerAfter ?? data?.registers?.[0]?.registerAfter,
            registerBefore: data.registers?.registerBefore ?? data?.registers?.[0]?.registerBefore,
            sendRoutePDFs: data.sendRoutePDF,
            subCategoriesPage: data.subCategoriesPage,
            routeCategories: data.routeCategories,
            recommendedRoutesHeader: data.recommendedRoutesHeader,
            recommendedRoutes: data.recommendedRoutes,
            kioskSurvey: data.kioskSurvey,
            deviceSurvey: data.deviceSurvey,
        }
    }

    updateDeviceSettings(data){
        this.device = { ...this.device,
            appID: data?.appID,
            type: data?.type,
            visualizeLines: data?.visualizeLines ?? true,
            client: data.clientID,
            styleLanguage: data.lang?.styleLanguage ?? this.device?.styleLanguage,
            logo: data.appStyle?.logo,
            slider: data.slider?.headerMultimedia,
            location: { 
              latitude: data.location?.lat,
              longitude: data.location?.lng,
              address: data.location?.address 
            },
            homeHeader: {
              name: data.slider?.headerName,
              description: data.slider?.headerDescription
            },
            style: {
              colorCorp1: data.appStyle?.corpColor1,
              colorCorp2: data.appStyle?.corpColor2,
              corpCompl: data.appStyle?.corpCompl,
              headerColor: data.appStyle?.headerColor,
              backgroundColor: data.appStyle?.backgroundColor
            }
          }
    }

    setDefaultDeviceSettings(){
        if (!this.responseData) return;
        const response = JSON.parse(JSON.stringify(this.responseData));
        if (!response) return;
        const data = response.data;
        this.device = {
            mac: data.distributorID,
            nameIndex: data.nameIndex,
            type: data.type,
            deviceClientID: data.deviceClientID,
            device: data.deviceID,
            channel: data.channelID,
            client: data.clientID,
            logo: data.appStyle?.logo,
            slider: data.slider?.headerMultimedia,
            languages: data.lang?.languages,
            mainLanguage: data.lang?.mainLanguage,
            styleLanguage: data.lang?.styleLanguage,
            location: {
              latitude: data.location?.lat,
              longitude: data.location?.lng,
              address: data.location?.address
            },
            selfieMasks: data.selfieMasks,
            design: data.totemDesign,
            newDesign : data.totemNewDesign,
            visualizeLines: data.visualizeLines ?? true,
            weather: data?.weather?.cod == 429 ? null : data?.weather,
            homeHeader: {
              name: data.slider?.headerName,
              description: data.slider?.headerDescription
            },
            reels: {
              active: data?.reels?.data?.length > 0 || false, 
              items: data.reels, 
              timeToEnterReels: 120
            },
            style: {
              colorCorp1: data.appStyle?.corpColor1,
              colorCorp2: data.appStyle?.corpColor2,
              corpCompl: data.appStyle?.corpCompl,
              headerColor: data.appStyle?.headerColor,
              backgroundColor: data.appStyle?.backgroundColor
            },
            appID: data?.appId,
            distributorID: data.distributorID,
          }
    }

    setDefaultCiceroneData(){
        if (!this.responseData) return;
        const response = JSON.parse(JSON.stringify(this.responseData));
        if (!response) return;
        const data = response.data;
        this.ciceroneData = {
            interestPoints: data.interestPoints,
            events: data.events,
            hikings: data.hikings,
            pdfs: data.pdfs,
            travelerType: data.travelerType,
            categories: data.categories,
            sortedCategories: data.sortedCategories,
            client_ids: data.clients,
            subCategories: data?.subCategories ?? data?.subcategories ?? [],
            accessibilities: data.accessibilities,
            tags: data.tags,
            registerAfter: data.registers?.registerAfter,
            registerBefore: data.registers?.registerBefore,
            provinces: data.provinces,
            countries: data.countries,
            sendRoutePDFs: data.sendRoutePDF,
            subCategoriesPage: data.subCategoriesPage,
            routeCategories: data.routeCategories,
            recommendedRoutesHeader: data.recommendedRoutesHeader,
            recommendedRoutes: data.recommendedRoutes,
            kioskSurvey: data.kioskSurvey,
            deviceSurvey: data.deviceSurvey,
            recommendedRoutesList: data.recommendedRoutesList,
            homePoints: data.homePoints,
            appsList: data.appsList
        }
    }

}